

























































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import {
  deleteDefinitionById,
  fetchDefinitionsList,
  updateDefinition,
  resetDefinitionBiId
} from '../services/stats-client'
import { DefinitionShowData, DefinitionsListData } from '../types/index.d'
import DefinitionsList from '../components/DefinitionsList.vue'

export default mixins(Pagination).extend({
  name: 'Definitions',
  components: {
    DefinitionsList
  },
  data () {
    return {
      isLoading: true,
      headers: [
        { text: 'Code', value: 'code', sortable: false },
        { text: 'Version', value: 'version', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Init With', value: 'init_with', sortable: false },
        { text: 'Reset', value: 'reset', sortable: false },
        { text: 'Actions', value: '_id', align: 'center', sortable: false }
      ],
      itemsList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchDefinitionsList(`?limit=${this.rowsPerPage}&offset=${this.paginationOffset}`)
        .then(({ items, total }: DefinitionsListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: DefinitionShowData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.$store.commit('global/setLoading', false)
          this.isLoading = false
        })
    },
    onDeleteDefinition (id: string) {
      this.isLoading = true
      deleteDefinitionById(id)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully deleted definitions!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onResetDefinition (id: string) {
      this.isLoading = true
      resetDefinitionBiId(id)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully reseted definition!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
})
